import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { TooltipPosition, MatDialog } from '@angular/material';
import { ToastrService } from 'ngx-toastr';
import { NavigationService } from 'services/navigation.service';
import { UserService } from 'services/user.service';
import { UserSessionService } from 'services/usersession.service';
import { SupportStatusComponent } from '../support/support-status/support-status.component';

@Component({
  selector: 'app-support-ticket',
  templateUrl: './support-ticket.component.html',
  styleUrls: ['./support-ticket.component.scss']
})
export class SupportTicketComponent implements OnInit {

  supportForm: FormGroup;

  isTooltipOpen = false;
  internetAccDetailsForm: FormGroup;
  logForm: FormGroup;
  userID: number = 0;
  roleDetailsEnum: any;
  homeLanguage: number;
  data: any;
  filteredList: any[];
  toShow = false;
  listNotFound: any = null;
  hide = true;
  supportList: any[];
  getroleDetailsList: [] = [];
  showCustomer :boolean;
  makeQueryExpand = false;
  positionOptions: TooltipPosition[] = ['below', 'above', 'left', 'right'];
  position = new FormControl(this.positionOptions[0]);
  sessionDataString: any;

  constructor(
    private fb: FormBuilder,
    private userServices: UserService,
    private session: UserSessionService,
    private navigate: NavigationService,
    public dialog: MatDialog,
    private toastr: ToastrService,
  ) {
        this.getActiveNewTickts();
   
  }

  ngOnInit(): void {
    this.initializeValidators();
 

  }
  addTicketRequest() {
    this.navigate.addsupport();
  }

  expand() {
    this.makeQueryExpand = true;
  }

  clkTicketStatus(item:any) {
    const dialogRef = this.dialog.open(SupportStatusComponent, {
      autoFocus: false,
      disableClose: true,
      panelClass: '',
      width:" 900px",
      data: { isshow: item }
    });
  }
  getActiveNewTickts() {
      this.userServices.getQContactTicketList().subscribe((data: any) => {
          if (data.isSuccess) {
            this.supportList = data.value;
            if (this.supportList.length > 0) {
              this.listNotFound = true;
              this.showCustomer = true;
            }
            else {
              this.listNotFound = false;
            }
          }
        },
        (error) => {
          console.error('Error in API call:', error);

        }
      );
  }
  initializeValidators() {
    this.supportForm = this.fb.group({
      supportList: [''],
      product: [''],
      address: [''],
      userName: [''],

    });
  }

  

}
